import React, { useContext, useState }from 'react'
import { Modal, Button } from 'react-bootstrap'
import { useMutation } from '@apollo/react-hooks'
import SelectedRowsInList from './FileManagement/SelectedRowsInList'
import GET_SAVE_QUERY from './FileManagement/UpdateFile'
import {AppNavContext} from './App'
import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'

export default function CancelFileChangeModal(props) {
  const appNav = useContext(AppNavContext)
  const { id } = useParams()
  const itemId = id
  const [ saveFile ] = useMutation(
    GET_SAVE_QUERY
  )

  const [ loading, setLoading ] = useState(false)
  const [ saveMessage, setSaveMessage ] = useState('If you leave this page, any changes you have made will be lost. Are you sure you wish to leave the page?')

  const selectedRows = props.selectedRows.map(element => (
    {
      'cuid': element.cuid,
      'title':  element.title,
      'useForPreview': element.useForPreview,
      'key': element.key
    }
  ))

  const redirect = () => {
    let url = process.env.REACT_APP_CATALOG_URI + '/item/' + itemId + '?a=' + new Date().getTime()
    window.location.replace(url)
  }

  return (
    <Modal {...props} size='md' scrollable={true}>
      <Modal.Header closeButton>
        <Modal.Title>Unsaved Changes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form
          onSubmit= {e => {
            e.preventDefault()
            setSaveMessage('Your changes are being saved.')
            setLoading(true)
            saveFile(
              {
                variables: {
                  input: {
                    selectedRows: selectedRows
                  }
                }
              }
            ).then(() => {
              setSaveMessage('If you leave this page, any changes you have made will be lost. Are you sure you wish to leave the page?')
              setLoading(true)
             // props.onClear()
              props.onHide()
              redirect()
            })
          }}>
          <p>{saveMessage}</p>
          <div>
            <SelectedRowsInList selectedRows={props.selectedRows} loading={loading}></SelectedRowsInList>
          </div>
          <Modal.Footer>
            <Button variant='primary' disabled={selectedRows.length<=0} type='submit'>Save Changes</Button>
            <Button variant='outline-primary' href={process.env.REACT_APP_CATALOG_URI + '/item/' + itemId + '?a=' + new Date().getTime()}>Discard Changes</Button>
            <Button variant='secondary' onClick={props.onHide}>Cancel</Button>
          </Modal.Footer>
        </form>
      </Modal.Body>
    </Modal>
  )
}

CancelFileChangeModal.propTypes = {
  onHide: PropTypes.func,
  selectedRows: PropTypes.any,
  onClear: PropTypes.func
}
